import { defineMessages } from "react-intl";

export const messages = defineMessages({
	patientList: {
		id: "patient_list.title",
		defaultMessage: "Páciens lista"
	}
});
